export default __webpack_public_path__ + "static/media/carpet.fb1370e2.svg";